/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren, useRef } from 'react';
import { jsx, css } from '@emotion/react';
import {
  createDecorator,
  Field,
  Form, MoneyInput,
  validate,
} from 'components/form';
import * as yup from 'yup';
import { FormattedMessage, useIntl } from 'components/i18n';
import Textarea from '@atlaskit/textarea';
import { RadioGroup, Radio } from '@atlaskit/radio';
import { saleItemType } from '../messages';
import { SaleItem, VatCode } from '../types';
import { VatCodeSelect } from '../../../components/select';
import TextAreaWithVariables from './TextAreaWithVariables';

const defaultProps = {};

type Props = {
  id?: string;
  onSubmit: (saleItem: SaleItem) => any;
  initialValues: SaleItem;
} & typeof defaultProps;

const schema = yup.object({
  type: yup.string().required('Required')
});

const saleItemTypeOptions = [
  {
    name: 'type',
    value: 'service',
    label: <FormattedMessage {...saleItemType.service} />,
  },
  {
    name: 'type',
    value: 'product',
    label: <FormattedMessage {...saleItemType.product} />,
  },
];

// const vatCodeDecorator = createDecorator({
//   field: /vatCode/, // when vatCode changes set vatCodeId
//   updates: {
//     vatCodeId:  (vatCode: any, allValues: Object | undefined)  => vatCode.id || '',
//   },
// });

const SaleItemForm = ({onSubmit, initialValues, id}: PropsWithChildren<Props>) => {
  const isNew = !initialValues.id;
  const intl = useIntl();
  return (
    <Form<SaleItem>
      onSubmit={(values) => onSubmit(values)}
      initialValues={initialValues}
      validate={validate(schema)}
    >
      {({ handleSubmit, values, form }) => {
        const { type } = values;
        const isService = type === 'service';
        return (
          <form onSubmit={handleSubmit}>
            <button id={id || 'saleItemForm'} type={"submit"} style={{display: 'none'}}>Submit</button>
            <Field name="type" label="Type">
              {({ input }) => (
                <div
                  css={css`
                  display: flex;
                  justify-content: space-between;
                `}
                >
                  <div
                    css={css`
                    div {
                    display: flex;
                    margin-left: -5px;
                    }
                  `}
                  >
                    <RadioGroup options={saleItemTypeOptions} {...input} />
                  </div>
                </div>
              )}
            </Field>

            <Field
              label={
                <FormattedMessage
                  id="sale.SaleItemForm.name"
                  defaultMessage="Name"
                />
              }
              autoFocus
              name="name"
              component={TextAreaWithVariables}
              rows={1}
              minimumRows={1}
            />
            <Field
              label={
                <FormattedMessage
                  id="sale.SaleItemForm.description"
                  defaultMessage="Description"
                />
              }
              name="description"
              component={TextAreaWithVariables}
              rows={1}
              minimumRows={1}
            />
            <Field
              label={
                <FormattedMessage
                  id="sale.SaleItemForm.vatCode"
                  defaultMessage="VAT Code"
                />
              }
              name="vatCodeId"
              component={VatCodeSelect}
              sale
              width={'small'}
              menuPortalTarget={document.body} // for modal
              // stfetchSaleItemsyles={{
              //   // menuPortal: (base:any) => ({
              //   //   ...base,
              //   //   zIndex: 9999,
              //   // }),
              // }}
            />
            <Field
              label={
                <FormattedMessage
                  id="sale.SaleItemForm.price"
                  defaultMessage="Price"
                />
              }
              name="price"
              component={MoneyInput}
              width={'small'}

            />
          </form>
        );
      }}
    </Form>
  );
};

SaleItemForm.defaultProps = defaultProps;

export default SaleItemForm;
